import {postReview} from "../api";

export function productTabs() {

    const product_tabs = $(".woo-product-tabs");
    const tabs_menu = product_tabs.find(".tabs-menu");
    const tabs_content = product_tabs.find(".tabs-content");
    const tabs_link = tabs_menu.find("a");
    const show_more = tabs_content.find("a.show-more");
    const show_reviews = $(".woo-product-info .p-title .reviews a");
    const submit_comment = tabs_content.find(".submit-request");
    const first_comment = tabs_content.find(".first-comment");
    const post_review = $("form#post-review");
    const stars = tabs_content.find(".my-rating .stars");
    const single_star = $(".post-review .my-rating .stars svg");

    let ul_w = 0;
    let hash = window.location.hash;

    setTimeout(function() {

        if(hash) {
            // console.log(hash);
            setActiveTab(tabs_menu, hash.substring(1));
        } else {
            console.log("nav-hash");
            setActiveTab(tabs_menu, false);
        }

    }, 100);

    // console.log(ul_w);

    show_reviews.on("click tap", function(e) {

        $('html, body').animate({
            scrollTop: $(".woo-product-tabs").offset().top
        }, 800);

        setActiveTab(tabs_menu, "reviews");
        return false;
    });

    tabs_link.on("click tap", function () {
        let me = $(this);
        let parent = me.parent();
        let li_w = parent.outerWidth();
        let target = parent.data("tab-target");
        let tab = tabs_content.find('.tab[data-tab-content="'+target+'"]');
        let pos = me.position();
        $( ".woo-product-tabs .tabs-menu" ).scrollLeft( pos.left - li_w );
        showTab(parent, tab, target);
        return false;
    });

    first_comment.on("click tap", function () {
        askLogin()
    });

    show_more.on("click tap", function () {
        let me = $(this);
        let parent = me.parent();

        parent.toggleClass("show-all");

        if(parent.hasClass("show-all")) {
            me.text(me.data("text-less"))
        } else {
            me.text(me.data("text-more"))
        }

        console.log("show more");
        return false;
    });

    single_star.hover(
        function() {
            stars.removeClass("selected");
            setStar($(this))
        }, function() {
            let me = $(this);

            if(!stars.hasClass("selected")) {

                if(me.parent().hasClass("not-logged")) {
                    stars.attr("class", "stars not-logged");
                } else {
                    stars.attr("class", "stars");
                    $("input#rating").val(0);
                }

            } else {
                setStar($(this))
            }

        }
    );

    single_star.on("click tap", function() {
        let me = $(this);
        let ind = me.index();
        let parent = me.parent()
        ind = ind + 1;
        console.log(ind)

        if(parent.hasClass("not-logged")) {
            askLogin()
        } else {

            parent.parent().removeClass("error");
            parent.addClass("selected")
            parent.attr("class","stars selected rating-" + ind)
            $("input#rating").val(ind);

            // if(!me.parent().hasClass("selected")) {
            //
            // } else {
            //     stars.parent().removeClass("error");
            // }

        }

    });

    post_review.on("submit", function () {
        let me = $(this);
        let data =  me.serializeArray();
        postReview(me,data);
        return false;
    });

    submit_comment.on("click tap", function () {
        let me = $(this);
        post_review.submit();
        return false;
    });

    function setStar(me) {
        let ind = me.index();
        ind = ind + 1;

        if(!me.parent().hasClass("selected")) {

            if(me.parent().hasClass("not-logged")) {
                me.parent().attr("class", "stars not-logged rating-"+ ind);
            } else {
                me.parent().attr("class","stars rating-" + ind)
                $("input#rating").val(ind);
            }

        }

        // console.log(ind);
    }

    function setActiveTab(tabs_menu, hash) {
        tabs_menu.find("li").each(function () {
            let me = $(this);
            let target;
            let li_w = me.outerWidth();

            // console.log(li_w);

            ul_w = ul_w + li_w;

            if ( window.innerWidth < 400 ) {
                $(".woo-product-tabs .tabs-menu ul").width(ul_w + 20);
            }

            if(hash) {
                target = hash;
                let tab = tabs_content.find('.tab[data-tab-content="'+target+'"]');

                if(me.data("tab-target") == target) {
                    showTab(me, tab, target);
                }

            } else {
                target = me.data("tab-target");
                let tab = tabs_content.find('.tab[data-tab-content="'+target+'"]');

                if(me.hasClass("active")) {
                    showTab(me, tab, target);
                }

            }

        });
    }

    function showTab(me, tab, target) {
        me.addClass("active").siblings().removeClass("active");
        tab.stop().fadeIn(600).siblings().hide();
        window.location.hash = target;
        // console.log(target);
    }

}

function askLogin() {
    console.log("ask login")
    $("body").addClass("show-fast-login");
    $("html").removeClass("menu-opened");
    $(".mobile-menu-toggle").addClass("is-hidden");
}